/* tslint:disable */
/* eslint-disable */
/**
 * Pitango Market API
 * Canonical public and administrative HTTP API contract.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
    AdminCategoriesPayloadICreateCategoryRequest,
    AdminCategoriesPayloadIUpdateCategoryRequest,
    AdminCategoriesPayloadIUpsertCategoryTranslateRequest,
    AdminCategoriesResponseCreateCategoryResponse,
    AdminCategoriesResponseDeleteCategoryResponse,
    AdminCategoriesResponseDeleteCategoryTranslateResponse,
    AdminCategoriesResponseGetCategoriesResponse,
    AdminCategoriesResponseGetCategoryByIdResponse,
    AdminCategoriesResponseGetCategoryTranslationsResponse,
    AdminCategoriesResponseRemoveCategoryImageResponse,
    AdminCategoriesResponseUpdateCategoryImageResponse,
    AdminCategoriesResponseUpdateCategoryResponse,
    AdminCategoriesResponseUpsertCategoryTranslateResponse,
    ApiErrorEnvelope,
    CategoriesResponseGetCategoriesResponse,
    CategoriesResponseGetCategoryResponse,
    LanguageCode,
} from '../models/index';

export interface AdminCategoriesCreateCategoryRequest {
    adminCategoriesPayloadICreateCategoryRequest: AdminCategoriesPayloadICreateCategoryRequest;
}

export interface AdminCategoriesDeleteCategoryRequest {
    categoryId: string;
}

export interface AdminCategoriesDeleteCategoryTranslateRequest {
    categoryId: string;
    languageCode: LanguageCode;
}

export interface AdminCategoriesGetCategoriesRequest {
    q?: string;
    active?: boolean;
    pageIndex?: number;
    pageSize?: number;
    languageCode?: string;
}

export interface AdminCategoriesGetCategoryByIdRequest {
    categoryId: string;
}

export interface AdminCategoriesGetCategoryTranslationsRequest {
    categoryId: string;
}

export interface AdminCategoriesRemoveCategoryImageRequest {
    categoryId: string;
}

export interface AdminCategoriesUpdateCategoryRequest {
    categoryId: string;
    adminCategoriesPayloadIUpdateCategoryRequest: AdminCategoriesPayloadIUpdateCategoryRequest;
}

export interface AdminCategoriesUpdateCategoryImageRequest {
    categoryId: string;
    image: Blob;
}

export interface AdminCategoriesUpsertCategoryTranslateRequest {
    categoryId: string;
    languageCode: LanguageCode;
    adminCategoriesPayloadIUpsertCategoryTranslateRequest: AdminCategoriesPayloadIUpsertCategoryTranslateRequest;
}

export interface CategoriesGetCategoriesRequest {
    languageCode: LanguageCode;
}

export interface CategoriesGetCategoryRequest {
    languageCode: LanguageCode;
    categoryId: string;
}

export interface CategoriesGetCategoryImageRequest {
    imageFile: string;
}

/**
 *
 */
export class CategoriesApi extends runtime.BaseAPI {

    /**
     * Creates request options for adminCategoriesCreateCategory without sending the request
     */
    async adminCategoriesCreateCategoryRequestOpts(requestParameters: AdminCategoriesCreateCategoryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['adminCategoriesPayloadICreateCategoryRequest'] == null) {
            throw new runtime.RequiredError(
                'adminCategoriesPayloadICreateCategoryRequest',
                'Required parameter "adminCategoriesPayloadICreateCategoryRequest" was null or undefined when calling adminCategoriesCreateCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/categories`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminCategoriesPayloadICreateCategoryRequest'],
        };
    }

    /**
     * Create Category
     */
    async adminCategoriesCreateCategoryRaw(requestParameters: AdminCategoriesCreateCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminCategoriesResponseCreateCategoryResponse>> {
        const requestOptions = await this.adminCategoriesCreateCategoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create Category
     */
    async adminCategoriesCreateCategory(requestParameters: AdminCategoriesCreateCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminCategoriesResponseCreateCategoryResponse> {
        const response = await this.adminCategoriesCreateCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminCategoriesDeleteCategory without sending the request
     */
    async adminCategoriesDeleteCategoryRequestOpts(requestParameters: AdminCategoriesDeleteCategoryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['categoryId'] == null) {
            throw new runtime.RequiredError(
                'categoryId',
                'Required parameter "categoryId" was null or undefined when calling adminCategoriesDeleteCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/categories/{categoryId}`;
        urlPath = urlPath.replace('{categoryId}', encodeURIComponent(String(requestParameters['categoryId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete Category
     */
    async adminCategoriesDeleteCategoryRaw(requestParameters: AdminCategoriesDeleteCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminCategoriesResponseDeleteCategoryResponse>> {
        const requestOptions = await this.adminCategoriesDeleteCategoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Delete Category
     */
    async adminCategoriesDeleteCategory(requestParameters: AdminCategoriesDeleteCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminCategoriesResponseDeleteCategoryResponse> {
        const response = await this.adminCategoriesDeleteCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminCategoriesDeleteCategoryTranslate without sending the request
     */
    async adminCategoriesDeleteCategoryTranslateRequestOpts(requestParameters: AdminCategoriesDeleteCategoryTranslateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['categoryId'] == null) {
            throw new runtime.RequiredError(
                'categoryId',
                'Required parameter "categoryId" was null or undefined when calling adminCategoriesDeleteCategoryTranslate().'
            );
        }

        if (requestParameters['languageCode'] == null) {
            throw new runtime.RequiredError(
                'languageCode',
                'Required parameter "languageCode" was null or undefined when calling adminCategoriesDeleteCategoryTranslate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/categories/{categoryId}/translations/{languageCode}`;
        urlPath = urlPath.replace('{categoryId}', encodeURIComponent(String(requestParameters['categoryId'])));
        urlPath = urlPath.replace('{languageCode}', encodeURIComponent(String(requestParameters['languageCode'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete Category Translate
     */
    async adminCategoriesDeleteCategoryTranslateRaw(requestParameters: AdminCategoriesDeleteCategoryTranslateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminCategoriesResponseDeleteCategoryTranslateResponse>> {
        const requestOptions = await this.adminCategoriesDeleteCategoryTranslateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Delete Category Translate
     */
    async adminCategoriesDeleteCategoryTranslate(requestParameters: AdminCategoriesDeleteCategoryTranslateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminCategoriesResponseDeleteCategoryTranslateResponse> {
        const response = await this.adminCategoriesDeleteCategoryTranslateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminCategoriesGetCategories without sending the request
     */
    async adminCategoriesGetCategoriesRequestOpts(requestParameters: AdminCategoriesGetCategoriesRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        if (requestParameters['pageIndex'] != null) {
            queryParameters['pageIndex'] = requestParameters['pageIndex'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['languageCode'] != null) {
            queryParameters['languageCode'] = requestParameters['languageCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/categories`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Categories
     */
    async adminCategoriesGetCategoriesRaw(requestParameters: AdminCategoriesGetCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminCategoriesResponseGetCategoriesResponse>> {
        const requestOptions = await this.adminCategoriesGetCategoriesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Categories
     */
    async adminCategoriesGetCategories(requestParameters: AdminCategoriesGetCategoriesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminCategoriesResponseGetCategoriesResponse> {
        const response = await this.adminCategoriesGetCategoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminCategoriesGetCategoryById without sending the request
     */
    async adminCategoriesGetCategoryByIdRequestOpts(requestParameters: AdminCategoriesGetCategoryByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['categoryId'] == null) {
            throw new runtime.RequiredError(
                'categoryId',
                'Required parameter "categoryId" was null or undefined when calling adminCategoriesGetCategoryById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/categories/{categoryId}`;
        urlPath = urlPath.replace('{categoryId}', encodeURIComponent(String(requestParameters['categoryId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Category By Id
     */
    async adminCategoriesGetCategoryByIdRaw(requestParameters: AdminCategoriesGetCategoryByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminCategoriesResponseGetCategoryByIdResponse>> {
        const requestOptions = await this.adminCategoriesGetCategoryByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Category By Id
     */
    async adminCategoriesGetCategoryById(requestParameters: AdminCategoriesGetCategoryByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminCategoriesResponseGetCategoryByIdResponse> {
        const response = await this.adminCategoriesGetCategoryByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminCategoriesGetCategoryTranslations without sending the request
     */
    async adminCategoriesGetCategoryTranslationsRequestOpts(requestParameters: AdminCategoriesGetCategoryTranslationsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['categoryId'] == null) {
            throw new runtime.RequiredError(
                'categoryId',
                'Required parameter "categoryId" was null or undefined when calling adminCategoriesGetCategoryTranslations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/categories/{categoryId}/translations`;
        urlPath = urlPath.replace('{categoryId}', encodeURIComponent(String(requestParameters['categoryId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Category Translations
     */
    async adminCategoriesGetCategoryTranslationsRaw(requestParameters: AdminCategoriesGetCategoryTranslationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminCategoriesResponseGetCategoryTranslationsResponse>> {
        const requestOptions = await this.adminCategoriesGetCategoryTranslationsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Category Translations
     */
    async adminCategoriesGetCategoryTranslations(requestParameters: AdminCategoriesGetCategoryTranslationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminCategoriesResponseGetCategoryTranslationsResponse> {
        const response = await this.adminCategoriesGetCategoryTranslationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminCategoriesRemoveCategoryImage without sending the request
     */
    async adminCategoriesRemoveCategoryImageRequestOpts(requestParameters: AdminCategoriesRemoveCategoryImageRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['categoryId'] == null) {
            throw new runtime.RequiredError(
                'categoryId',
                'Required parameter "categoryId" was null or undefined when calling adminCategoriesRemoveCategoryImage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/categories/{categoryId}/image`;
        urlPath = urlPath.replace('{categoryId}', encodeURIComponent(String(requestParameters['categoryId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Remove Category Image
     */
    async adminCategoriesRemoveCategoryImageRaw(requestParameters: AdminCategoriesRemoveCategoryImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminCategoriesResponseRemoveCategoryImageResponse>> {
        const requestOptions = await this.adminCategoriesRemoveCategoryImageRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Remove Category Image
     */
    async adminCategoriesRemoveCategoryImage(requestParameters: AdminCategoriesRemoveCategoryImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminCategoriesResponseRemoveCategoryImageResponse> {
        const response = await this.adminCategoriesRemoveCategoryImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminCategoriesUpdateCategory without sending the request
     */
    async adminCategoriesUpdateCategoryRequestOpts(requestParameters: AdminCategoriesUpdateCategoryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['categoryId'] == null) {
            throw new runtime.RequiredError(
                'categoryId',
                'Required parameter "categoryId" was null or undefined when calling adminCategoriesUpdateCategory().'
            );
        }

        if (requestParameters['adminCategoriesPayloadIUpdateCategoryRequest'] == null) {
            throw new runtime.RequiredError(
                'adminCategoriesPayloadIUpdateCategoryRequest',
                'Required parameter "adminCategoriesPayloadIUpdateCategoryRequest" was null or undefined when calling adminCategoriesUpdateCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/categories/{categoryId}`;
        urlPath = urlPath.replace('{categoryId}', encodeURIComponent(String(requestParameters['categoryId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminCategoriesPayloadIUpdateCategoryRequest'],
        };
    }

    /**
     * Update Category
     */
    async adminCategoriesUpdateCategoryRaw(requestParameters: AdminCategoriesUpdateCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminCategoriesResponseUpdateCategoryResponse>> {
        const requestOptions = await this.adminCategoriesUpdateCategoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Update Category
     */
    async adminCategoriesUpdateCategory(requestParameters: AdminCategoriesUpdateCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminCategoriesResponseUpdateCategoryResponse> {
        const response = await this.adminCategoriesUpdateCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminCategoriesUpdateCategoryImage without sending the request
     */
    async adminCategoriesUpdateCategoryImageRequestOpts(requestParameters: AdminCategoriesUpdateCategoryImageRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['categoryId'] == null) {
            throw new runtime.RequiredError(
                'categoryId',
                'Required parameter "categoryId" was null or undefined when calling adminCategoriesUpdateCategoryImage().'
            );
        }

        if (requestParameters['image'] == null) {
            throw new runtime.RequiredError(
                'image',
                'Required parameter "image" was null or undefined when calling adminCategoriesUpdateCategoryImage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['image'] != null) {
            formParams.append('image', requestParameters['image'] as any);
        }


        let urlPath = `/admin/categories/{categoryId}/image`;
        urlPath = urlPath.replace('{categoryId}', encodeURIComponent(String(requestParameters['categoryId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        };
    }

    /**
     * Update Category Image
     */
    async adminCategoriesUpdateCategoryImageRaw(requestParameters: AdminCategoriesUpdateCategoryImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminCategoriesResponseUpdateCategoryImageResponse>> {
        const requestOptions = await this.adminCategoriesUpdateCategoryImageRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Update Category Image
     */
    async adminCategoriesUpdateCategoryImage(requestParameters: AdminCategoriesUpdateCategoryImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminCategoriesResponseUpdateCategoryImageResponse> {
        const response = await this.adminCategoriesUpdateCategoryImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminCategoriesUpsertCategoryTranslate without sending the request
     */
    async adminCategoriesUpsertCategoryTranslateRequestOpts(requestParameters: AdminCategoriesUpsertCategoryTranslateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['categoryId'] == null) {
            throw new runtime.RequiredError(
                'categoryId',
                'Required parameter "categoryId" was null or undefined when calling adminCategoriesUpsertCategoryTranslate().'
            );
        }

        if (requestParameters['languageCode'] == null) {
            throw new runtime.RequiredError(
                'languageCode',
                'Required parameter "languageCode" was null or undefined when calling adminCategoriesUpsertCategoryTranslate().'
            );
        }

        if (requestParameters['adminCategoriesPayloadIUpsertCategoryTranslateRequest'] == null) {
            throw new runtime.RequiredError(
                'adminCategoriesPayloadIUpsertCategoryTranslateRequest',
                'Required parameter "adminCategoriesPayloadIUpsertCategoryTranslateRequest" was null or undefined when calling adminCategoriesUpsertCategoryTranslate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/categories/{categoryId}/translations/{languageCode}`;
        urlPath = urlPath.replace('{categoryId}', encodeURIComponent(String(requestParameters['categoryId'])));
        urlPath = urlPath.replace('{languageCode}', encodeURIComponent(String(requestParameters['languageCode'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminCategoriesPayloadIUpsertCategoryTranslateRequest'],
        };
    }

    /**
     * Upsert Category Translate
     */
    async adminCategoriesUpsertCategoryTranslateRaw(requestParameters: AdminCategoriesUpsertCategoryTranslateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminCategoriesResponseUpsertCategoryTranslateResponse>> {
        const requestOptions = await this.adminCategoriesUpsertCategoryTranslateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Upsert Category Translate
     */
    async adminCategoriesUpsertCategoryTranslate(requestParameters: AdminCategoriesUpsertCategoryTranslateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminCategoriesResponseUpsertCategoryTranslateResponse> {
        const response = await this.adminCategoriesUpsertCategoryTranslateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for categoriesGetCategories without sending the request
     */
    async categoriesGetCategoriesRequestOpts(requestParameters: CategoriesGetCategoriesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['languageCode'] == null) {
            throw new runtime.RequiredError(
                'languageCode',
                'Required parameter "languageCode" was null or undefined when calling categoriesGetCategories().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/categories/{languageCode}`;
        urlPath = urlPath.replace('{languageCode}', encodeURIComponent(String(requestParameters['languageCode'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Categories
     */
    async categoriesGetCategoriesRaw(requestParameters: CategoriesGetCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CategoriesResponseGetCategoriesResponse>> {
        const requestOptions = await this.categoriesGetCategoriesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Categories
     */
    async categoriesGetCategories(requestParameters: CategoriesGetCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CategoriesResponseGetCategoriesResponse> {
        const response = await this.categoriesGetCategoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for categoriesGetCategory without sending the request
     */
    async categoriesGetCategoryRequestOpts(requestParameters: CategoriesGetCategoryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['languageCode'] == null) {
            throw new runtime.RequiredError(
                'languageCode',
                'Required parameter "languageCode" was null or undefined when calling categoriesGetCategory().'
            );
        }

        if (requestParameters['categoryId'] == null) {
            throw new runtime.RequiredError(
                'categoryId',
                'Required parameter "categoryId" was null or undefined when calling categoriesGetCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/categories/{languageCode}/{categoryId}`;
        urlPath = urlPath.replace('{languageCode}', encodeURIComponent(String(requestParameters['languageCode'])));
        urlPath = urlPath.replace('{categoryId}', encodeURIComponent(String(requestParameters['categoryId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Category
     */
    async categoriesGetCategoryRaw(requestParameters: CategoriesGetCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CategoriesResponseGetCategoryResponse>> {
        const requestOptions = await this.categoriesGetCategoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Category
     */
    async categoriesGetCategory(requestParameters: CategoriesGetCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CategoriesResponseGetCategoryResponse> {
        const response = await this.categoriesGetCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for categoriesGetCategoryImage without sending the request
     */
    async categoriesGetCategoryImageRequestOpts(requestParameters: CategoriesGetCategoryImageRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['imageFile'] == null) {
            throw new runtime.RequiredError(
                'imageFile',
                'Required parameter "imageFile" was null or undefined when calling categoriesGetCategoryImage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/categories/images/{imageFile}`;
        urlPath = urlPath.replace('{imageFile}', encodeURIComponent(String(requestParameters['imageFile'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Category Image
     */
    async categoriesGetCategoryImageRaw(requestParameters: CategoriesGetCategoryImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const requestOptions = await this.categoriesGetCategoryImageRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Get Category Image
     */
    async categoriesGetCategoryImage(requestParameters: CategoriesGetCategoryImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.categoriesGetCategoryImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
